export const versionPlatforms = {
    fbox: {
        createButtonKey: 'pages.versions.create.button',
        createTitleKey: 'pages.versions.create.title',
        createFooterKey: 'pages.versions.create.footer',
        detailTitleKey: 'pages.versions.detail.title',
        editTitleKey: 'pages.versions.detail.editTitle',
        fileFieldKey: 'pages.versions.create.fields.fboxFile',
        routes: {
            list: () => '/devices/version',
            create: () => '/create/version',
            edit: id => `/create/version/${id}`,
            detail: id => `/version/detail/${id}`,
        },
        endpoints: {
            list: '/version/list/',
            create: '/version/create/',
            detail: id => `/version/${id}/`,
            devices: id => `/version/${id}/devices/`,
            companies: id => `/version/${id}/companies/`,
            // body: {ids, version} or {ids, fast_change: true} (latest STABLE)
            updateDevices: '/version/devices/update/',
            updateCompanies: '/version/companies/update/',
        },
    },
    fiscalMe: {
        createButtonKey: 'pages.versions.fiscalMe.create.button',
        createTitleKey: 'pages.versions.fiscalMe.create.title',
        createFooterKey: 'pages.versions.fiscalMe.create.footer',
        detailTitleKey: 'pages.versions.fiscalMe.detail.title',
        editTitleKey: 'pages.versions.fiscalMe.detail.editTitle',
        fileFieldKey: 'pages.versions.fiscalMe.create.fields.file',
        routes: {
            list: () => '/devices/fiscal-me/version',
            create: () => '/create/fiscal-me/version',
            edit: id => `/create/fiscal-me/version/${id}`,
            detail: id => `/fiscal-me/version/detail/${id}`,
        },
        endpoints: {
            list: '/version/fiscal-me/list/',
            create: '/version/fiscal-me/create/',
            detail: id => `/version/fiscal-me/${id}/`,
        },
    },
}

export const normalVersionConfig = versionPlatforms.fbox
export const fiscalMeVersionConfig = versionPlatforms.fiscalMe

export const getAuthHeaders = token => (
    token ? {Authorization: `Token ${token}`} : undefined
)
